module.exports = __webpack_public_path__ + "media/app/components/MainNav/Kamereo.3709e7c0.svg";